import variables from "src/common/assets/variables";

const Input: any = {
  borderWidth: 1,
  borderColor: variables.$divider,
  backgroundColor: variables.$background,
  borderRadius: variables.$size_9,
  height: 45,
};
const Button: any = {
  padding: 10,
  borderRadius: variables.$size_4,
  backgroundColor: variables.$buttonColor,
  height: 50
};
const ButtonSuccess: any = {
  backgroundColor: variables.$success,
};
const ButtonDanger: any = {
  backgroundColor: variables.$danger,
};
const ButtonWarning: any = {
  backgroundColor: variables.$warning,
};

export { Input, Button, ButtonDanger, ButtonSuccess, ButtonWarning };
